var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _path13, _path14, _path15, _path16, _path17, _path18, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeepOceanSubmarineGray = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#818A98"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0587 25.2123C12.656 27.0762 15.1307 37.7515 14.976 39.1071L29.6693 33.0069C26.2666 29.7874 18.7808 23.7212 16.0587 25.2123Z",
    fill: "#D5D8DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0587 64.9557C12.656 63.0917 15.1307 52.4165 14.976 51.0609L29.6693 57.161C26.2666 60.3806 18.7808 66.4468 16.0587 64.9557Z",
    fill: "#D5D8DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57015 45.6271C6.40665 42.6233 4.77775 36.09 7.57015 33.9874C10.3626 31.8847 8.73365 40.8711 7.57015 45.6271Z",
    fill: "#D5D8DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57015 45.6275C6.40665 48.3583 4.77775 54.2976 7.57015 56.2091C10.3626 58.1206 8.73365 49.9512 7.57015 45.6275Z",
    fill: "#D5D8DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5272 29.5114C77.0168 31.5313 77.9997 36.8703 77.9997 44.8337L77.9999 45.3038C78.0044 56.8139 78.0073 63.9753 52.865 63.9753C28.196 63.9753 10.5806 55.2854 9.48055 46.6087H8.7301C8.67827 47.1404 8.55312 47.685 8.31948 48.2029C7.32364 50.4103 5 47.0992 5 45.9955C5 44.8918 8.00882 42.4391 8.31948 43.5428C8.45988 43.8886 8.62403 44.4596 8.70645 45.1371H9.44849C9.95277 38.3342 18.9079 33.444 35.5704 30.6981C36.1866 28.521 37.1918 25.443 38.8732 24.1467C41.0316 22.4825 44.3376 19.9553 49.2369 18.9523C49.2369 14.4074 49.2369 13.5062 50.347 11.6552C51.6708 9.44774 54.0622 9.07076 56.3993 9.04542C56.8878 9.04013 57.3298 9.03533 57.7124 9C57.9656 9.43382 58.2559 10.2728 58.1728 11.2531C58.1228 11.8431 57.7124 13.1696 57.7124 13.1696C57.7124 13.1696 55.8486 13.2577 55.0185 13.1696C53.5183 13.0103 52.7299 13.5415 52.3148 13.9568C51.8642 14.4076 51.815 14.9774 51.856 18.6884C55.0234 18.8604 68.5272 19.4431 68.5272 24.1467V29.5114Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0872 22.969C67.7179 19.5724 55.0476 16.6705 51.8649 16.2097C51.8309 16.9845 51.8575 18.6874 51.8649 19.364C54.065 19.4848 66.0868 20.8758 68.0872 22.969Z",
    fill: "#D5D8DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2899 16.2097C46.8631 16.2239 42.8526 16.894 41.0502 18.9133C39.6982 20.4279 38.9434 22.8854 39.2477 23.8702C44.2045 20.2652 47.8094 19.364 49.2899 19.364C49.2249 18.5494 49.3114 17.1635 49.2899 16.2097Z",
    fill: "#D5D8DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6426 30.6297C37.6669 29.9077 58.317 29.5114 68.087 29.2858C66.857 28.5714 62.1407 27.165 53.1157 27.2552C41.8345 27.368 41.0359 22.8806 39.2435 24.7984C37.8096 26.3326 36.0994 29.0127 35.6426 30.6297Z",
    fill: "#9DA4AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6114 17.1107C49.6095 17.058 49.6077 17.0066 49.6062 16.9564C49.6078 17.0074 49.6095 17.0588 49.6114 17.1107Z",
    fill: "#9DA4AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6114 17.1107C49.6095 17.058 49.6077 17.0066 49.6062 16.9564C49.5251 14.3479 49.8248 12.8416 50.9633 11.7033L50.964 11.7026C52.3156 10.3511 53.2167 9.45003 57.2715 9.4502L57.2716 11.2527C56.034 10.6925 53.1658 11.0997 51.4142 13.0551C49.7151 14.9519 49.5563 15.3318 49.6062 16.9564C49.6078 17.0074 49.6095 17.0588 49.6114 17.1107Z",
    fill: "#9DA4AF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0988 45.0493C66.2552 47.2128 65.3357 46.7472 10.2847 47.2881C12.1721 55.6287 26.5164 60.7225 44.258 62.6817C73.8312 64.8452 75.5888 57.5879 77.0988 52.4941C77.0988 51.3791 77.0988 46.2248 77.0988 45.0493Z",
    fill: "#9DA4AF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45021 47.2881C8.01984 50.1431 5 47.8289 5 46.2063C5.71478 46.2777 7.74474 47.2201 8.45021 47.2881Z",
    fill: "#9DA4AF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.6998,
    cy: 14.1903,
    rx: 13.6998,
    ry: 14.1903,
    transform: "matrix(0.894018 0.448031 -0.409149 0.912468 45.3936 27.1541)",
    fill: "#D5D8DD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.71803,
    cy: 9.03017,
    rx: 8.71803,
    ry: 9.03017,
    transform: "matrix(0.894018 0.448031 -0.409149 0.912468 47.7354 34.095)",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3883 46.0337C65.414 47.9153 65.0888 49.7837 64.4314 51.5324C63.774 53.2812 62.7972 54.8758 61.5568 56.2255C60.3165 57.5751 58.8368 58.6532 57.2023 59.3983C55.5678 60.1434 53.8105 60.5408 52.0307 60.568C50.2509 60.5951 48.4835 60.2513 46.8294 59.5563C45.1753 58.8613 43.6668 57.8287 42.3902 56.5174C41.1136 55.2061 40.0937 53.6418 39.389 51.9138C38.6842 50.1859 38.3082 48.3281 38.2826 46.4465L51.8355 46.2401L65.3883 46.0337Z",
    fill: "#67717E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4596 46.1307C60.4871 48.549 59.6049 50.8797 58.0069 52.6103C56.409 54.3409 54.2262 55.3295 51.9387 55.3586C49.6513 55.3878 47.4466 54.4551 45.8096 52.7658C44.1726 51.0764 43.2375 48.7688 43.2099 46.3506L51.8347 46.2407L60.4596 46.1307Z",
    fill: "#B9BEC6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3384 60.6032C29.9712 50.8616 31.9354 35.8476 33.3384 31.4763L30.9425 31.8546C28.4572 41.3152 29.4645 55.5145 30.6002 59.8467L33.3384 60.6032Z",
    fill: "#D5D8DD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6003 60.4583C66.9613 49.4608 69.9295 35.5759 71.7947 30.4873L69.4059 29.7285C65.3026 41.0018 65.6122 50.7432 68.2114 61.217L70.6003 60.4583Z",
    fill: "#D5D8DD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6743 37.6952C75.6746 36.2187 73.3758 33.7143 72.2263 32.6466C70.6384 32.2873 70.9358 34.2004 71.7793 34.622C72.6229 35.0436 73.1932 37.1338 73.4658 38.6952C73.7385 40.2566 75.674 39.5409 75.6743 37.6952Z",
    fill: "#D5D8DD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0485 24.3225C66.6797 22.7631 63.5144 20.6675 61.9778 19.8147C60.1339 19.8147 60.9406 21.764 61.9778 22.0077C63.015 22.2514 64.1674 24.3225 64.8589 25.9064C65.5503 27.4902 67.5095 26.2719 67.0485 24.3225Z",
    fill: "#D5D8DD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.1943,
    y: 43.4539,
    width: 14.3904,
    height: 5.4333,
    rx: 2.71665,
    fill: "#D5D8DD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeepOceanSubmarineGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DeepOceanSubmarine-gray.3a6c7e90c0f9019e7f61dbf904eeefee.svg";